import { render, staticRenderFns } from "./BitacoraNovedadesGraficas.vue?vue&type=template&id=58b31d1c"
import script from "./BitacoraNovedadesGraficas.vue?vue&type=script&lang=js"
export * from "./BitacoraNovedadesGraficas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports